export default "__VITE_ASSET__BAY9K5o1__"